import React, { useContext } from 'react';
import styled from 'styled-components';
import { StaticImage } from 'gatsby-plugin-image';
import { VisuallyLogo } from '@/features/strapi/components/logo';
import { StrapiTextual } from '@/features/strapi/components/textual';
import { AccountContext } from '@/features/account-context';
import { breakpoints } from '@/components/responsive';
import { routes } from '@/webapi/routes';
import { DynamicComponent } from '@/components/dynamic-component';
import {
  MobileMenuButton,
  useMobileMenu,
} from '@/components/mobile-menu/button';
import { MobileMenuOverlay } from '@/components/mobile-menu/overlay';

export function Header() {
  const {
    account: { isLoggedIn },
  } = useContext(AccountContext);

  const onLogin = () => {
    if (!isLoggedIn) {
      window.location.replace(`/login`);
    } else {
      window.location.replace(`/dashboard`);
    }
  };

  const { isMenuOpen, openMenu, closeMenu } = useMobileMenu();

  return (
    <>
      <DynamicComponent
        url={routes.promotionBarContent}
        className="vsly-promobar"
      />
      <Wrapper id="header">
        <div style={{ pointerEvents: `none` }} />
        <LogoSection href="/">
          <VisuallyLogo wide />
        </LogoSection>
        <ControlsSection className="only-desktop">
          <StrapiTextual
            text="Inspirations"
            href="/public/inspirations/listing"
          />
          <StrapiTextual text="Customers" href="/public/customers" />
          <StrapiTextual text="Partners" href="/public/partners" />
          <StrapiTextual text="Pricing" href="/pricing" />
          <StrapiTextual
            text="Talk to an expert"
            href="/public/talk-to-expert/"
          />
          <StrapiTextual
            text={isLoggedIn ? `Dashboard >` : `Login >`}
            style={{ textDecoration: `underline` }}
            onClick={onLogin}
          />
          {!isLoggedIn && (
            <div className="trial">
              <StaticImage
                src="blackshopify.png"
                alt=""
                loading="eager"
                placeholder="none"
                width={15}
              />
              <StrapiTextual
                text="Start free trial"
                size="1.4rem"
                href="https://apps.shopify.com/visually-io"
              />
            </div>
          )}
        </ControlsSection>
        <MobileMenuButton onClick={openMenu} />
        <div style={{ pointerEvents: `none` }} />
      </Wrapper>
      {isMenuOpen && (
        <MobileMenuOverlay onClose={closeMenu} onBackdropClicked={closeMenu}>
          <StrapiTextual href="/public/customers" text="Customers" />
          <StrapiTextual href="/public/partners" text="Partners" />
          <StrapiTextual href="/pricing" text="Pricing" />
          <StrapiTextual
            href="/public/inspirations/listing"
            text="Inspirations"
          />
          <StrapiTextual
            href="/public/talk-to-expert"
            text="Talk to an expert"
          />
          <StrapiTextual
            text={isLoggedIn ? `Dashboard` : `Login`}
            style={{ textDecoration: `underline` }}
            onClick={onLogin}
          />
          <StrapiTextual
            className="btn primary-btn"
            href="https://apps.shopify.com/visually-io"
            text="Get Visually for free"
          />
        </MobileMenuOverlay>
      )}
    </>
  );
}

const Wrapper = styled.div`
  z-index: 10;
  position: relative;
  display: grid;
  grid-template-columns: 4rem 1fr 1fr 4rem;
  width: 100%;
  height: auto;
  padding: 3rem 0;
  background: transparent;

  ${breakpoints.down(`md`)} {
    grid-template-columns: 3rem 1fr 4rem;
  }

  .trial {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-gap: 1.5rem;
    justify-content: center;
    align-items: center;
    border: 1px solid black;
    border-radius: 3rem;
    padding: 0.8rem 2rem;
  }

  transition: background-color 0.2s ease-in-out;

  .trial:hover {
    filter: invert(1);
    background: white;
  }

  .menu-btn {
    position: absolute;
    top: 2.7rem;
    right: 2rem;
  }
`;

const LogoSection = styled.a`
  display: flex;
`;

const ControlsSection = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  && > * {
    margin-left: 5rem;
    letter-spacing: -0.5px;
    font-size: 1.5rem;
    ${breakpoints.up(`xl`)} {
      font-size: 1.7rem;
    }
  }
`;
